module.exports = __webpack_public_path__ + "static/media/Nodata.7bc140bc.svg";